import { useMutation, useQuery, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import useAuthStore from '../store/authStore';
import { getPageContent, updatePageContent } from '../api/pagesSettings';

export const usePageContent = (pageType) => {
  const { setError } = useAuthStore();
  const queryClient = useQueryClient();

  const {
    data: pageContent,
    isLoading,
    error,
    refetch
  } = useQuery(
    ['page', pageType],
    () => getPageContent(pageType),
    {
      onError: (error) => {
        const errorMessage = error?.response?.data?.message || `Failed to fetch ${pageType} content`;
        setError(errorMessage);
        toast.error(errorMessage);
      },
      retry: 1,
      staleTime: 300000, // 5 minutes
      cacheTime: 3600000, // 1 hour
      enabled: pageType !== undefined
    }
  );

  const updateMutation = useMutation(
    ({ pageType, content }) => updatePageContent(pageType, content),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['page', pageType]);
        toast.success(`${pageType.charAt(0).toUpperCase() + pageType.slice(1)} content updated successfully!`);
      },
      onError: (error) => {
        const errorMessage = error?.response?.data?.message || `Failed to update ${pageType} content`;
        setError(errorMessage);
        toast.error(errorMessage);
      }
    }
  );

  return {
    pageContent,
    isLoading,
    error,
    refetch,
    updateContent: (content) => updateMutation.mutate({ pageType, content }),
    isUpdating: updateMutation.isLoading
  };
};
